import Task from "../../entities/task";

/**
 * Task actions
 *
 * Call order:
 *
 * TASK_SAVE_QUEUE:	adds the item to the save queue
 * --> TASK_SAVE:	modifies the state
 * --> TASK_SAVE_SUCCESS: if all went well
 * --> TASK_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail TASK_SAVE_QUEUE is during the call to TASK_SAVE,
 * as adding an item to the queue should never fail.
 */

export const TASK_FETCH_ONE_QUEUE: any = 'TASK_FETCH_ONE_QUEUE';
export const TASK_FETCH_SUCCESS: any = 'TASK_FETCH_SUCCESS';
export const TASK_FETCH_FAILURE: any = 'TASK_FETCH_FAILURE';
export const TASK_FETCH_ONE_SUCCESS: any = 'TASK_FETCH_ONE_SUCCESS';
export const TASK_FETCH_ONE_FAILURE: any = 'TASK_FETCH_ONE_FAILURE';

export const TASK_SAVE: any = 'TASK_SAVE';
export const TASK_SAVE_QUEUE: any = 'TASK_SAVE_QUEUE';
export const TASK_SAVE_SUCCESS: any = 'TASK_SAVE_SUCCESS';
export const TASK_SAVE_FAILURE: any = 'TASK_SAVE_FAILURE';

export const TASK_SAVE_MANY: any = 'TASK_SAVE_MANY';
export const TASK_SAVE_MANY_QUEUE: any = 'TASK_SAVE_MANY_QUEUE';
export const TASK_SAVE_MANY_SUCCESS: any = 'TASK_SAVE_MANY_SUCCESS';
export const TASK_SAVE_MANY_FAILURE: any = 'TASK_SAVE_MANY_FAILURE';

export const TASK_REMOVE: any = 'TASK_REMOVE';
export const TASK_REMOVE_QUEUE: any = 'TASK_REMOVE_QUEUE';
export const TASK_REMOVE_SUCCESS: any = 'TASK_REMOVE_SUCCESS';
export const TASK_REMOVE_FAILURE: any = 'TASK_REMOVE_FAILURE';

export const TASK_RESTORE: any = 'TASK_RESTORE';
export const TASK_RESTORE_QUEUE: any = 'TASK_RESTORE_QUEUE';
export const TASK_RESTORE_SUCCESS: any = 'TASK_RESTORE_SUCCESS';
export const TASK_RESTORE_FAILURE: any = 'TASK_RESTORE_FAILURE';

export const TASK_RESTORE_MANY: any = 'TASK_RESTORE_MANY';
export const TASK_REMOVE_MANY: any = 'TASK_REMOVE_MANY';

/* Fetch actions */
export const fetchTaskSuccess = (tasks: Task[], partial: boolean, lastFetch: number) => ({type: TASK_FETCH_SUCCESS, tasks, partial, lastFetch});
export const fetchTaskFailure = (err: any) => {
		console.error('TaskAction: fetchTaskFailure', err);
		return {type: TASK_FETCH_FAILURE, err};
};
export const fetchOneTaskQueue = (taskId: string) => ({type: TASK_FETCH_ONE_QUEUE, taskId});
export const fetchOneTaskSuccess = (task: Task) => ({type: TASK_FETCH_ONE_SUCCESS, task});
export const fetchOneTaskFailure = (id: string, err: any) => {
		console.error('TaskAction: fetchOneTaskFailure', err);
		return {type: TASK_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveTask = (task: Task) => {
    // console.debug('⮂ TASK_SAVE action', task?.id);
    return {type: TASK_SAVE, task};
}
export const saveTaskQueue = (task: Task) => {
    // console.debug('⮂ TASK_SAVE_QUEUE action', task?.id);
    return {type: TASK_SAVE_QUEUE, task};
}
export const saveTaskSuccess = (task: Task) => {
    // console.debug('⮂ TASK_SAVE_SUCCESS action', task?.id);
    return {type: TASK_SAVE_SUCCESS, task};
}
export const saveTaskFailure = (task: Task, status: number, message: string) => {
    console.warn(`⮂ TASK_SAVE_FAILURE error saving task: HTTP ${status}: ${message}`, task?.id);
    return {type: TASK_SAVE_FAILURE, task, status, message};
};

/* SaveMany actions */
export const saveManyTasks = (tasks: Task[]) => {
    // console.debug('⮂ TASK_SAVE_MANY action', tasks?.map(task => task?.id).join(','));
    return {type: TASK_SAVE_MANY, tasks};
}
export const saveManyTasksQueue = (tasks: Task[]) => {
    // console.debug('⮂ TASK_SAVE_MANY_QUEUE action', tasks?.map(task => task.id).join(','));
    return {type: TASK_SAVE_MANY_QUEUE, tasks};
}

export const saveManyTasksSuccess = (tasks: Task[]) => {
    // console.debug('⮂ TASK_SAVE_MANY_SUCCESS action', tasks?.map(task => task.id).join(','));
    return {type: TASK_SAVE_MANY_SUCCESS, tasks};
}
export const saveManyTasksFailure = (tasks: Task[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_TASKS_FAILURE Error saving tasks: HTTP ${status}: ${message}`, tasks?.map(task => task.id).join(','));
		return {type: TASK_SAVE_MANY_FAILURE, tasks, status, message};
};

/* Remove actions */
export const removeTask = (task: Task) => ({ type: TASK_REMOVE, task });
export const removeTaskQueue = (task: Task) => ({ type: TASK_REMOVE_QUEUE, task });
export const removeTaskSuccess = (task: Task) => ({ type: TASK_REMOVE_SUCCESS, task });
export const removeTaskFailure = (task: Task, status: number, message: string) => {
	console.error(`Redux: removeTaskFailure Error removing task: HTTP ${status}: ${message}`);
	return ({ type: TASK_REMOVE_FAILURE, task, status, message });
};

/* Restore actions */
export const restoreTask = (task: Task) => ({ type: TASK_RESTORE, task });
export const restoreTaskQueue = (task: Task) => ({ type: TASK_RESTORE_QUEUE, task });
export const restoreTaskSuccess = (task: Task) => ({ type: TASK_RESTORE_SUCCESS, task });
export const restoreTaskFailure = (task: Task, status: number, message: string) => {
	console.error(`Redux: restoreTaskFailure Error restoring task: HTTP ${status}: ${message}`);
	return ({ type: TASK_RESTORE_FAILURE, task, status, message });
};

/* RestoreMany actions */
export const restoreManyTasks = (tasks: Task[]) => ({ type: TASK_RESTORE_MANY, tasks });

/* RemoveMany actions */
export const removeManyTasks = (tasks: Task[]) => ({ type: TASK_REMOVE_MANY, tasks });